<script lang="ts" setup>
const { t } = useI18n();
const localePath = useLocalePath();
</script>

<template>
  <PageContainer class="p-2 text-center text-neutral-600 my-30">
    <div ref="backgroundEl" class="parallax-background">
      <img fetchpriority="low" src="/assets/images/bg.svg" alt="Background" />
    </div>
    <h1 class="text-[15rem] max-lg:text-[8rem] mb-2 m-0">404</h1>
    <h2>
      {{ t("notFound") }}
    </h2>
    <PageButton :to="localePath('/')" class="!m-8">
      {{ t("goHomeButton") }}
    </PageButton>
  </PageContainer>
</template>
